import script from "./message.vue?vue&type=script&setup=true&lang=js"
export * from "./message.vue?vue&type=script&setup=true&lang=js"

import "./message.vue?vue&type=style&index=0&id=40d8eba0&lang=css"

const __exports__ = script;

export default __exports__